export const IP_LOCATION_FETCH_REQUESTED = 'IP_LOCATION_FETCH_REQUESTED';
export const IP_LOCATION_FETCH_SUCCEEDED = 'IP_LOCATION_FETCH_SUCCEEDED';
export const IP_LOCATION_FETCH_FAILED = 'IP_LOCATION_FETCH_FAILED';
